import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
export const ThreeAnimation = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!containerRef.current) return;
    // Scene setup
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, 1, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({
      alpha: true
    });
    const resize = () => {
      if (!containerRef.current) return;
      const width = containerRef.current.clientWidth;
      const height = containerRef.current.clientHeight;
      renderer.setSize(width, height);
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
    };
    renderer.setPixelRatio(window.devicePixelRatio);
    resize();
    containerRef.current.appendChild(renderer.domElement);
    // Create particles
    const particlesGeometry = new THREE.BufferGeometry();
    const particleCount = 100;
    const posArray = new Float32Array(particleCount * 3);
    for (let i = 0; i < particleCount * 3; i++) {
      posArray[i] = (Math.random() - 0.5) * 5;
    }
    particlesGeometry.setAttribute('position', new THREE.BufferAttribute(posArray, 3));
    const particlesMaterial = new THREE.PointsMaterial({
      size: 0.02,
      color: '#4F46E5',
      transparent: true,
      opacity: 0.8
    });
    const particlesMesh = new THREE.Points(particlesGeometry, particlesMaterial);
    scene.add(particlesMesh);
    // Add lines between points
    const linesMaterial = new THREE.LineBasicMaterial({
      color: '#4F46E5',
      transparent: true,
      opacity: 0.2
    });
    const linesGeometry = new THREE.BufferGeometry();
    const positions: number[] = [];
    for (let i = 0; i < particleCount; i++) {
      for (let j = i + 1; j < particleCount; j++) {
        const distance = Math.sqrt(Math.pow(posArray[i * 3] - posArray[j * 3], 2) + Math.pow(posArray[i * 3 + 1] - posArray[j * 3 + 1], 2) + Math.pow(posArray[i * 3 + 2] - posArray[j * 3 + 2], 2));
        if (distance < 1) {
          positions.push(posArray[i * 3], posArray[i * 3 + 1], posArray[i * 3 + 2], posArray[j * 3], posArray[j * 3 + 1], posArray[j * 3 + 2]);
        }
      }
    }
    linesGeometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
    const linesMesh = new THREE.LineSegments(linesGeometry, linesMaterial);
    scene.add(linesMesh);
    camera.position.z = 5;
    // Animation
    const animate = () => {
      requestAnimationFrame(animate);
      particlesMesh.rotation.x += 0.001;
      particlesMesh.rotation.y += 0.001;
      linesMesh.rotation.x += 0.001;
      linesMesh.rotation.y += 0.001;
      renderer.render(scene, camera);
    };
    animate();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
      containerRef.current?.removeChild(renderer.domElement);
      scene.remove(particlesMesh);
      scene.remove(linesMesh);
      particlesGeometry.dispose();
      particlesMaterial.dispose();
      linesGeometry.dispose();
      linesMaterial.dispose();
      renderer.dispose();
    };
  }, []);
  return <div ref={containerRef} className="absolute inset-0" data-id="element-230" />;
};